
import React from 'react';

interface IOSInstallPromptProps {
    onClose: () => void;
}

const IOSInstallPrompt: React.FC<IOSInstallPromptProps> = ({ onClose }) => {
    return (
        <div className="fixed inset-0 z-[200] bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center pt-0 px-4 pb-4" onClick={onClose}>
            <div 
                className="bg-white dark:bg-stone-800 rounded-2xl w-full max-w-sm p-6 shadow-2xl animate-in slide-in-from-bottom-10 duration-300"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex flex-col items-center text-center gap-4">
                    <div>
                        <h3 className="text-lg font-serif font-bold text-stone-900 dark:text-white">Install App on iOS</h3>
                        <p className="text-sm text-stone-500 dark:text-stone-400 mt-2">
                           To add this app to your home screen, follow these simple steps in Safari.
                        </p>
                    </div>
                    
                    <div className="space-y-4 text-left w-full bg-stone-50 dark:bg-stone-900/50 p-4 rounded-lg border border-stone-200 dark:border-stone-700">
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white rounded-lg text-lg font-bold shrink-0">1</div>
                            <p className="flex-1 text-sm text-stone-700 dark:text-stone-300">
                                Tap the <strong className="font-bold">Share</strong> button in the browser toolbar.
                            </p>
                            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 dark:bg-stone-700 rounded-md shrink-0">
                                <i className="fa-solid fa-arrow-up-from-bracket text-blue-500"></i>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white rounded-lg text-lg font-bold shrink-0">2</div>
                            <p className="flex-1 text-sm text-stone-700 dark:text-stone-300">
                                Scroll down and tap on <strong className="font-bold">Add to Home Screen</strong>.
                            </p>
                            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 dark:bg-stone-700 rounded-md shrink-0">
                                <i className="fa-solid fa-plus-square text-blue-500"></i>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-3 w-full mt-2">
                        <button 
                            onClick={onClose} 
                            className="flex-1 py-3 text-stone-500 dark:text-stone-400 font-bold hover:bg-stone-100 dark:hover:bg-stone-700 rounded-xl transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IOSInstallPrompt;
